module.exports = __webpack_public_path__ + "img/zncs.6337c03c.png";